import { Link } from "react-router-dom";
import { cpfMask, phoneMask } from "../utils/functions";

const YES_NO = { true: "Sim", false: "Não" };
const digits = (value) => String(value ?? "").replace(/\D/g, "");
const check = (value) => (value ? "✔" : "");

export const USER_COLUMNS = [
    { key: "_id", header: "ID", visible: false, persist: false, hideable: false, filter: "ids", exportable: false },
    { key: "name", header: "Nome", width: 180, filter: "list" },
    { key: "email", header: "Email", width: 220, filter: "text" },
    { key: "documentNumber", header: "CPF", width: 130, filter: "digits", accessor: (row) => digits(row.documentNumber), format: (value) => cpfMask(value) },
    { key: "createdAt", header: "Criado", width: 110, type: "date", filter: "date" },
    { key: "birth", header: "Nascimento", width: 110, type: "date", filter: "date", visible: false },
    { key: "phone", header: "Telefone", width: 140, filter: "digits", accessor: (row) => digits(row.phone), format: (value) => phoneMask(value) },
    { key: "admin", header: "Admin", width: 90, filter: "list", accessor: (row) => Boolean(row.roles?.includes("admin")), labels: YES_NO, format: check, cellClassName: () => "text-green-500" },
    { key: "partner", header: "Parceiro", width: 90, filter: "list", accessor: (row) => Boolean(row.roles?.includes("partner")), labels: YES_NO, format: check, cellClassName: () => "text-green-500" },
    {
        key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
        cell: ({ row }) => <Link to={`/manafix/users/${row._id}`} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</Link>,
    },
];
